export const LANGUAGE_CHOICE_MODE = Object.freeze({
    LOGIN: 'login',
    SWITCH: 'switch',
});

const MODES = Object.values(LANGUAGE_CHOICE_MODE);

// `current` is the account language at log-in and the language on screen when switching.
const OPTION_EFFECTS = Object.freeze({
    [LANGUAGE_CHOICE_MODE.LOGIN]: {
        current: { tag: 'ACCOUNT', caption: 'CAPTION_ACCOUNT', description: 'DESCRIPTION_USE', saveToProfile: false, reload: true, dismiss: false, arrow: false },
        proposed: { tag: 'LOGIN_SCREEN', caption: 'CAPTION_LOGIN_SCREEN', description: 'DESCRIPTION_USE', saveToProfile: true, reload: false, dismiss: false, arrow: true },
    },
    [LANGUAGE_CHOICE_MODE.SWITCH]: {
        current: { tag: 'CURRENT', caption: 'CAPTION_KEEP', description: 'DESCRIPTION_KEEP', saveToProfile: false, reload: false, dismiss: true, arrow: false },
        proposed: { tag: 'NEW', caption: 'CAPTION_SWITCH', description: 'DESCRIPTION_SWITCH', saveToProfile: true, reload: true, dismiss: false, arrow: true },
    },
});

const isSupported = (language, supported) => supported.includes(language);

const createChoice = (mode, current, proposed, supported) => {
    if (!isSupported(current, supported) || !isSupported(proposed, supported) || current === proposed) {
        return null;
    }

    return { mode, current, proposed };
};

export const buildLoginLanguageChoice = ({ accountLanguage, screenLanguage, supported, fallback }) => {
    const current = isSupported(accountLanguage, supported) ? accountLanguage : fallback;

    return createChoice(LANGUAGE_CHOICE_MODE.LOGIN, current, screenLanguage, supported);
};

export const buildSwitchLanguageChoice = ({ currentLanguage, nextLanguage, supported }) =>
    createChoice(LANGUAGE_CHOICE_MODE.SWITCH, currentLanguage, nextLanguage, supported);

export const normalizeLanguageChoice = (value, supported) => {
    if (!value || typeof value !== 'object' || !MODES.includes(value.mode)) {
        return null;
    }

    return createChoice(value.mode, value.current, value.proposed, supported);
};

export const getLanguageChoiceOptions = ({ mode, current, proposed }) => {
    const effects = OPTION_EFFECTS[mode];

    return [
        { language: current, ...effects.current },
        { language: proposed, ...effects.proposed },
    ];
};
